(function () {
  // ====== CSS luxury per la tabella (iniettato per ultimo) ======
  const CSS = `
  .lhb-size-clean { 
    width:100% !important; max-width:100% !important; 
    border-collapse:collapse !important; border-spacing:0 !important; 
    table-layout:auto !important; margin:1.5em 0 !important; 
    font-size:14px !important; line-height:1.5 !important; color:#e6e6e6 !important; 
    border:1px solid rgba(193,165,98,.35) !important;
  }
  .lhb-size-clean th, .lhb-size-clean td{
    padding:10px 12px !important; text-align:center !important; vertical-align:middle !important;
    border:1px solid rgba(193,165,98,.35) !important; font-weight:400 !important; 
    white-space:normal !important; word-break:normal !important;
  }
  .lhb-size-clean thead th{
    color:#c1a562 !important; text-transform:uppercase !important; letter-spacing:.5px !important;
    font-weight:600 !important; font-size:13px !important; border-bottom:2px solid #c1a562 !important; 
    background:transparent !important;
  }
  .lhb-size-clean tr:nth-child(even) td{ background:rgba(255,255,255,.02) !important; }
  .lhb-size-clean tr:hover td{ background:rgba(193,165,98,.08) !important; }
  @media(max-width:768px){
    .lhb-size-clean{ font-size:12px !important; }
    .lhb-size-clean th,.lhb-size-clean td{ padding:6px 8px !important; }
  }`;

  function injectStyleOnce() {
    if (document.getElementById('lhb-size-style')) return;
    const style = document.createElement('style');
    style.id = 'lhb-size-style';
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  // Rimuove attributi e stili inline "tossici"
  function stripInline(el) {
    const ATTRS = ['width','height','style'];
    ATTRS.forEach(a => {
      if (el.hasAttribute && el.hasAttribute(a)) {
        if (a === 'style') {
          const propsToKill = ['width','height','font-size','line-height','background','background-color','color','border','border-color','border-width','padding','margin'];
          propsToKill.forEach(p => el.style && el.style.removeProperty && el.style.removeProperty(p));
        } else {
          el.removeAttribute(a);
        }
      }
    });
  }

  function cleanTable(table) {
    const nodes = table.querySelectorAll('thead,tbody,tr,th,td,span,p,div');
    stripInline(table);
    nodes.forEach(stripInline);
    table.classList.add('lhb-size-clean');
  }

  function runOnce(root) {
    injectStyleOnce();
    const containers = root ? [root] : Array.from(document.querySelectorAll('.lhb-rte, .product__description, .product-single__description, .rte'));
    containers.forEach(c => {
      c.querySelectorAll('table').forEach(t => cleanTable(t));
    });
  }

  function boot() {
    runOnce();
    const obs = new MutationObserver(muts => {
      for (const m of muts) {
        m.addedNodes && m.addedNodes.forEach(n => {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches('table')) runOnce(n.parentElement || n);
          else if (n.querySelectorAll && n.querySelectorAll('table').length) runOnce(n);
        });
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => obs.disconnect(), 8000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ====== Allineamento colonna testo (v4: delta + translateX) ====== */
function __lhb_align() {
  const containers = document.querySelectorAll('.lhb-rte, .product__description, .product-single__description, .rte');

  containers.forEach(container => {
    const sample = container.querySelector('p, li, h2, h3, h4');
    const tables = container.querySelectorAll('table.lhb-size-clean');
    if (!sample || !tables.length) return;

    const sampleRect = sample.getBoundingClientRect();
    const widthPx    = Math.round(sampleRect.width);

    tables.forEach(t => {
      // Se la tabella è dentro un <p>, tirala fuori
      if (t.parentElement && t.parentElement.tagName === 'P') {
        const p = t.parentElement;
        const after = p.nextSibling;
        const wrap = document.createElement('div');
        wrap.className = 'lhb-size-wrap';
        p.parentNode.insertBefore(wrap, after || p.nextSibling);
        wrap.appendChild(t);
        if (!p.textContent.trim() && !p.querySelector('*')) p.remove();
      }

      // Crea wrapper se manca
      if (!t.parentElement.classList.contains('lhb-size-wrap')) {
        const wrap = document.createElement('div');
        wrap.className = 'lhb-size-wrap';
        t.parentElement.insertBefore(wrap, t);
        wrap.appendChild(t);
      }

      const wrap = t.parentElement;

      // Reset prima di misurare
      wrap.style.transform   = '';
      wrap.style.marginLeft  = '0';
      wrap.style.marginRight = '0';
      wrap.style.paddingLeft = '0';
      wrap.style.paddingRight= '0';
      wrap.style.width       = widthPx + 'px';
      wrap.style.maxWidth    = widthPx + 'px';

      // Calcola delta tra bordo sinistro del testo e del wrapper
      const wrapRect = wrap.getBoundingClientRect();
      const deltaX   = Math.round(sampleRect.left - wrapRect.left);
      wrap.style.transform = `translateX(${deltaX}px)`;
    });
  });
}

// Avvio + observer + resize (per breakpoint)
__lhb_align();
const __lhbAlignObs = new MutationObserver(() => __lhb_align());
__lhbAlignObs.observe(document.body, { childList: true, subtree: true });
window.addEventListener('resize', __lhb_align, { passive: true });
setTimeout(() => __lhbAlignObs.disconnect(), 8000);


